/**
 * Map capabilities to display rows for marketplace and integrations UI.
 * Provides getAvailableIntegrationsFromCapabilities and AvailableIntegrationRow.
 */

import { ALL_CAPABILITIES, type Capability } from "@/lib/platform/capabilities";
import { capabilityIdToIntegrationType } from "@/lib/utils/capabilityToIntegration";
import type { IntegrationType } from "@/types/integration";

export interface AvailableIntegrationRow {
  type: IntegrationType;
  name: string;
  description: string;
  icon: string;
  category: string;
  capability: Capability;
}

/**
 * Build list of integration rows from capability definitions.
 * Only includes capabilities that map to a known IntegrationType.
 */
export function getAvailableIntegrationsFromCapabilities(): AvailableIntegrationRow[] {
  const rows: AvailableIntegrationRow[] = [];
  for (const cap of ALL_CAPABILITIES) {
    const type = capabilityIdToIntegrationType(cap.id);
    if (!type) continue;
    rows.push({
      type,
      name: cap.name,
      description: cap.description,
      icon: cap.icon,
      category: cap.category,
      capability: cap,
    });
  }
  return rows;
}
